import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthState, User } from '../../types/auth.types';

const initialState: AuthState = {
  user: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
  avatar: "",
  phoneVerified: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
      state.isAuthenticated = !!action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearAuth: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.error = null;
      state.phoneVerified = false;
    },
    setAvatar: (state, action: PayloadAction<string | null>) => {
      state.avatar = action.payload;
    },
     setPhoneVerified: (state, action: PayloadAction<boolean>) => {
      state.phoneVerified = action.payload;
    },
      updateAuthField: (state, action) => {
    const { field, value } = action.payload;
    (state as any)[field] = value;
  },
  },
});

export const {
  setUser,
  setLoading,
  setError,
  clearAuth,
  setAvatar,
  setPhoneVerified,
  updateAuthField
} = authSlice.actions;

export default authSlice.reducer; 